import React, { useEffect, useState, useMemo } from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { SelectInput, useTranslate, useNotify, required, TextInput, useRefresh } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Delete, Add } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { Grid, Skeleton, Box, Tabs, Tab } from '@mui/material'
import { productServices } from 'src/services/reservation/product/product.service'
import AttachEmailIcon from '@mui/icons-material/AttachEmail'
import { EmailModalSetting } from 'src/components/pages/administration/work-unit/logic/EmailModalSetting'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { removeEmailsByIds } from 'src/components/pages/administration/helper'

export const SettingEmail = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { control } = useFormContext()
  const [loading, setLoading] = useState(false)
  const [optionsProduct, setOptionsProduct] = useState([])
  const [indexState, setIndexState] = useState(null)
  const [open, setOpen] = useState(false)
  const [currentTab, setCurrentTab] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'setting_email',
    keyName: '_id',
  })

  useEffect(() => {
    if (confirmDelete) {
      removeEmailsByIds(indexState, fields, remove, refresh, notify, setOpenModal)
      setConfirmDelete(false)
      setIndexState(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    ;(async () => {
      await getAllProducts()
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const getAllProducts = async () => {
    setLoading(true)
    try {
      const allProducts = await productServices.getByAll()
      if (allProducts) {
        setOptionsProduct(allProducts)
        setLoading(false)
        return
      }
      setOptionsProduct([])
      notify(`Products not found`, { type: 'error' })
      setLoading(false)
    } catch (error) {
      setOptionsProduct([])
      console.log('ModuleCreate Product getAll error: ', error)
      notify(`please, refresh page`, { type: 'error' })
      setLoading(false)
    }
  }

  const deleteEmail = (email, remove) => {
    console.log("email", email);
    console.log("remove", remove);
    if (!('new_register' in email)) {
      setOpenModal(true)
      setIndexState(email.index)
      return
    }
    remove(email.index)
  }

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue)
  }

  const categories = useMemo(() => {
    const categoryMap = {}
    if (Object.keys(categoryMap).length == 0){
      categoryMap['Nuevo'] = [] // agregar categoria cuando no haya productos
    }
    fields.forEach((field, index) => {
      if (field.isDelete) return
      if (field?.new_register){ // si el field fue agregado se quedara en la categoria 'Nuevo'
        const field_with_index = {...field, index : index}
        categoryMap['Nuevo'].push(field_with_index)
        return
      }
      const product = optionsProduct.find((p) => p.hash_product === field.product && !field?.new_register)
      if (product || !field.product) {
        const category = product?.long_name || 'Nuevo'
        if (!categoryMap[category]) {
          categoryMap[category] = []
        }
        const field_with_index = {...field, index : index}
        categoryMap[category].push(field_with_index)
      }
    })
    const categoriesArray = Object.keys(categoryMap).map((category) => ({
      label: category,
      fields: categoryMap[category],
    }));

    // si existe  la categoría "Nuevo",  agregarla al principio del array
    const nuevoCategoryIndex = categoriesArray.findIndex((c) => c.label === 'Nuevo');
    if (nuevoCategoryIndex !== -1) {
      const nuevoCategory = categoriesArray.splice(nuevoCategoryIndex, 1)[0];
      categoriesArray.unshift(nuevoCategory);
    }

    return categoriesArray;

  }, [fields, optionsProduct])

  return (
    <>
      {
        openModal &&
        <ConfirmationDialog
          title={translate('ra.message.delete_email')}
          buttonConfirmText={translate('ra.action.to_confirm')}
          buttonCancel={translate('ra.action.cancel')}
          setOpen={setOpenModal}
          setConfirm={setConfirmDelete}
          open={openModal}
        />
      }
      <Tabs value={currentTab} onChange={handleTabChange} 
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {categories.map((category, index) => (
          <Tab key={index} label={category.label} />
        ))}
      </Tabs>
      {categories[currentTab] &&
        React.Children.toArray(
          categories[currentTab].fields.map((field) => (
            <div
              key={field._id}
              style={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.product')} required lg={4} md={4} xs={4}>
                  {loading ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      source={`setting_email.${field.index}.product`}
                      optionText='long_name'
                      fullWidth
                      optionValue='hash_product'
                      choices={optionsProduct}
                      label={false}
                      validate={required()}
                    />
                  )}
                </EditInputsWrap>

                <EditInputsWrap label={translate('ra.field.status')} lg={4} md={4} xs={4}>
                  <TextInput
                    source={`setting_email.${field.index}.status`}
                    label={false}
                    fullWidth
                    disabled
                  />
                </EditInputsWrap>

                <Box paddingX={3} paddingY={10}>
                  <Button
                    startIcon={<AttachEmailIcon />}
                    onClick={() => {
                      handleOpen()
                      setIndexState(field.index)
                    }}
                  >
                    {translate('ra.field.setting_email')}
                  </Button>
                </Box>
                {open && indexState === field.index && (
                  <EmailModalSetting open={open} index={indexState} handleClose={handleClose} />
                )}
              </Grid>
              <Grid container spacing={3} justifyContent='flex-end' className='addItemSeparator'>
                <Grid item xs={12} sm={12} className='grid'>
                  <Button
                    onClick={() => deleteEmail(field, remove)}
                    startIcon={<Delete />}
                    color='error'
                  >
                    {translate('ra.action.delete')}
                  </Button>
                </Grid>
              </Grid>
            </div>
          ))
        )}
      {
        currentTab == 0 && // mostrar solo en la categoria "Nuevo"
        <Button
          startIcon={<Add />}
          onClick={() => {
            append({
              business_unit: null,
              content: null,
              footer: null,
              header: null,
              status: null,
              subject: null,
              work_unit: null,
              product : null,
              new_register: true
            })
          }}
        >
        {translate('ra.action.add')}
        </Button>
      }
    </>
  )
}
